import { render, staticRenderFns } from "./ScreenAdapter.vue?vue&type=template&id=cc266fbc&scoped=true&"
import script from "./ScreenAdapter.vue?vue&type=script&lang=js&"
export * from "./ScreenAdapter.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAdapter.vue?vue&type=style&index=0&id=cc266fbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc266fbc",
  null
  
)

export default component.exports